import { createSlice } from '@reduxjs/toolkit';
import { WebhookDetailStateType } from 'src/types/webhookDetail';

const initialState: WebhookDetailStateType = {
    data: null,
    changelog: null,
    loading: false,
    deleted: false,
    error: false,
};

export const webhookDetailSlice = createSlice({
    name: 'webhookDetail',
    initialState,
    reducers: {
        getWebhookDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getWebhookDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.changelog = null;
            state.loading = false;
        },
        getWebhookDetailFetchFailure: (state, action) => {
            state.data = null;
            state.changelog = null;
            state.loading = false;
            state.error = true;
        },
        getWebhookDetailHistoryFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getWebhookDetailHistoryFetchSuccess: (state, action) => {
            state.changelog = action.payload.data;
            state.loading = false;
        },
        getWebhookDetailHistoryFetchFailure: (state, action) => {
            state.changelog = null;
            state.loading = false;
            state.error = true;
        },
        createWebhookDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createWebhookDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        createWebhookDetailFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        updateWebhookDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateWebhookDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
            state.changelog = null;
        },
        updateWebhookDetailFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
            state.changelog = null;
        },
        deleteWebhookFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deleteWebhookFetchSuccess: (state, action) => {
            state.deleted = true;
            state.loading = false;
        },
        deleteWebhookFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        activateWebhookFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        activateWebhookFetchSuccess: (state, action) => {
            state.loading = false;
        },
        activateWebhookFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        deactivateWebhookFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deactivateWebhookFetchSuccess: (state, action) => {
            state.loading = false;
        },
        deactivateWebhookFetchFailure: (state, action) => {
            state.loading = false;
            state.error = true;
        },
        clearWebhookDetail: () => initialState,
    },
});

export const {
    getWebhookDetailFetch,
    getWebhookDetailFetchSuccess,
    getWebhookDetailFetchFailure,
    getWebhookDetailHistoryFetch,
    getWebhookDetailHistoryFetchSuccess,
    getWebhookDetailHistoryFetchFailure,
    createWebhookDetailFetch,
    createWebhookDetailFetchSuccess,
    createWebhookDetailFetchFailure,
    updateWebhookDetailFetch,
    updateWebhookDetailFetchSuccess,
    updateWebhookDetailFetchFailure,
    deleteWebhookFetch,
    deleteWebhookFetchSuccess,
    deleteWebhookFetchFailure,
    activateWebhookFetch,
    activateWebhookFetchSuccess,
    activateWebhookFetchFailure,
    deactivateWebhookFetch,
    deactivateWebhookFetchSuccess,
    deactivateWebhookFetchFailure,
    clearWebhookDetail,
} = webhookDetailSlice.actions;

export default webhookDetailSlice.reducer;
